export default __webpack_public_path__ + "static/media/icon_endtype_ClosedEndVCut.1d032b42.png";